import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EndPointsConfig } from '../../endpoints/endpoints.config';
import { WebapiService } from '../webapi/webapi.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userName: string;
  userId: number;
  userRoles: string[];
  private userNameSubject: Subject<string> = new Subject<string>();

  constructor(private webapiService: WebapiService) { }

  async OnInit() {
    await this.login();
  }

  async login() {
    let response;
    const endpointURL = '';
    await this.webapiService.postMethod(endpointURL, '')
      .toPromise().then((authResponse) => {
        response = authResponse;
        this.userId = response.id;
        this.userRoles = response.roles;
      }).catch((error) => {
        response = error;
      });
  }

  // Method to update the username
  updateUserName(newUserName: string) {
    this.userName = newUserName;
    // Emit the new username through the subject
    this.userNameSubject.next(newUserName);
  }

  // Method to get the current username
  getUserName(): string {
    return this.userName;
  }

  // Method to subscribe to username changes
  subscribeToUserNameChanges(): Subject<string> {
    return this.userNameSubject;
  }
}
